import { useTranslation } from 'react-i18next';
import { ApplicantStatus } from 'types/employee/IJobApplicant';
import { ReactComponent as EditEmployeeAvatar } from '../../assets/icons/EditEmployeeAvatar.svg';
import { getApplicantStatusTag } from './helpers';
import {
  CardAvatar,
  CardContactGroup,
  CardContent,
  ContactDetails,
  EmployeeCardStyled,
  EmployeeName,
  GreyedOutAvatar,
  StatusTag,
  StatusTagContainer,
  StatusTagIcon,
} from './styles';
import { ApplicantCardProps } from './types';

const ApplicantCard = (props: ApplicantCardProps): JSX.Element => {
  const { applicant, onClick } = props;
  const [t] = useTranslation();

  const isDiscarded = applicant.status === ApplicantStatus.Discarded;
  const statusTag = getApplicantStatusTag(applicant.status);

  return (
    <EmployeeCardStyled onClick={() => onClick(applicant.id)}>
      <CardContent>
        <CardAvatar>
          <GreyedOutAvatar isGreyedOut={isDiscarded}>
            <EditEmployeeAvatar width={56} height={56} />
          </GreyedOutAvatar>
        </CardAvatar>
        <EmployeeName>{`${applicant.firstName} ${applicant.lastName}`}</EmployeeName>
        <CardContactGroup>
          <ContactDetails>{applicant.phoneNumber}</ContactDetails>
          <ContactDetails>{applicant.emailAddress}</ContactDetails>
        </CardContactGroup>
        <StatusTagContainer>
          <StatusTag tone={statusTag.tone}>
            {statusTag.icon && (
              <StatusTagIcon>
                <statusTag.icon />
              </StatusTagIcon>
            )}
            {t(statusTag.labelKey)}
          </StatusTag>
        </StatusTagContainer>
      </CardContent>
    </EmployeeCardStyled>
  );
};

export default ApplicantCard;
